// extracted by mini-css-extract-plugin
module.exports = {"statsBox":"stats-box_statsBox__Bs2r2","statsBoxImgContainer":"stats-box_statsBoxImgContainer__PlAVY","statsBoxTextContainer":"stats-box_statsBoxTextContainer___vY4e"};